<template>
  <router-view></router-view>
</template>

<style lang="stylus">
  @import "./assets/css/normalize.css";
  @import "./assets/css/base.styl";
  @import "./assets/css/ui.styl";

  html
    height 100%

  body
    height 100%
    background-color #432a14
    bgImg("/img/bg/bg_brown_1.jpg")
    background-repeat repeat
    cursor url($resourceHost + "/img/cursor/Crcom000_HD.png") 0 0, default
    overscroll-behavior-y contain

</style>

<script>
  import { mapGetters } from 'vuex'
  import adapt from '@js/utils/adapt'

  export default {
    computed: {
      ...mapGetters('device', [
        'isMobile'
      ]),
    },

    created () {
      if (this.isMobile) {
        adapt(375, 10)
      }
    },

    async mounted () {
      document.addEventListener('contextmenu', (e) => {
        e.preventDefault()
      })
      document.querySelector('link[rel="icon"]').setAttribute('src', `${this.$rHost}/img/favicon.ico`)
      // special theme
      // const specialTheme = await API.system.specialTheme()
      // if (specialTheme === 'grayscale') {
      //   document.querySelector('html').style.filter = 'grayscale(1)'
      // }
    }
  }
</script>
